import ServiceTemplate from '@/components/ServiceTemplate';

export default function PatentApplication() {
  const data = {
    title: 'Patent Application Services',
    subtitle: 'Professional patent application preparation and filing to protect your inventions.',
    overviewTitle: 'Why File a Patent Application?',
    overviewImage: 'https://images.unsplash.com/photo-1581094271901-8022df4466f9',
    description: [
      'A patent grants exclusive rights to make, use, and sell your invention for 20 years. Proper patent application preparation is crucial for securing strong, enforceable patent protection.',
      'Patent applications require detailed technical descriptions, precise claims defining your invention\'s scope, and professional drawings meeting USPTO requirements.',
      'Our experienced patent attorneys work with inventors to prepare comprehensive applications that maximize protection while meeting all legal and technical requirements.'
    ],
    benefits: [
      { title: 'Exclusive Rights', description: 'Prevent others from making, using, or selling your invention.' },
      { title: '20-Year Protection', description: 'Secure long-term competitive advantage.' },
      { title: 'Licensing Opportunities', description: 'Generate revenue through licensing agreements.' },
      { title: 'Increased Valuation', description: 'Enhance company value for investors and acquisitions.' },
      { title: 'Market Position', description: 'Establish market dominance and barrier to entry.' },
      { title: 'Legal Recourse', description: 'Enforce rights against infringers through litigation.' }
    ],
    process: [
      { title: 'Research & Analysis', description: 'Comprehensive search and analysis to identify potential conflicts or issues.' },
      { title: 'Application Preparation & Filing', description: 'Expert preparation and filing of complete applications with all required documentation.' },
      { title: 'Monitoring & Approval', description: 'Track application progress and address any office actions until successful approval.' }
    ],
    pricing: [
      {
        name: 'Consultation',
        description: 'Patent evaluation',
        price: '$499',
        period: 'One-time fee',
        features: [
          'Patentability assessment',
          'Prior art search',
          'Patent strategy consultation',
          'Feasibility analysis',
          'Written opinion',
          'Filing recommendations'
        ]
      },
      {
        name: 'Utility Patent',
        description: 'Full patent application',
        price: '$5,999',
        period: '+ USPTO fees ($1,820)',
        featured: true,
        features: [
          'Everything in Consultation',
          'Complete patent drafting',
          'USPTO filing',
          'Office action responses (2 included)',
          'Prior art analysis',
          'Claims optimization',
          'Direct attorney access'
        ]
      },
      {
        name: 'Design Patent',
        description: 'Design protection',
        price: '$1,999',
        period: '+ USPTO fees ($860)',
        features: [
          'Design patent search',
          'Professional patent drawings',
          'Complete application',
          'USPTO filing',
          'Office action response (1 included)',
          'Expedited processing available',
          'Priority support'
        ]
      }
    ],
    faqs: [
      { question: 'What can be patented?', answer: 'New and useful processes, machines, manufactures, compositions of matter, and improvements thereof can be patented.' },
      { question: 'How long does it take to get a patent?', answer: 'Patent examination typically takes 1-3 years, though expedited examination options can reduce this time significantly.' },
      { question: 'What is a provisional patent?', answer: 'A provisional application establishes an early filing date and "patent pending" status but requires a non-provisional filing within 12 months.' },
      { question: 'How much does a patent cost?', answer: 'Costs vary widely based on complexity, typically ranging from $8,000-$15,000+ for preparation and filing, plus USPTO fees.' },
      { question: 'Should I file provisional or non-provisional?', answer: 'Provisional applications are less expensive and provide a 12-month window to assess commercial viability before committing to full application.' },
      { question: 'What are patent claims?', answer: 'Claims define the legal scope of your patent protection and are the most important part of the application.' },
      { question: 'Can I file internationally?', answer: 'Yes, through PCT international applications or direct filing in foreign countries, though costs increase significantly.' },
      { question: 'What happens during examination?', answer: 'A USPTO examiner reviews your application and typically issues office actions requiring responses before granting the patent.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
